import React from 'react'
import { CurrentDepositWrapper, DepositTitle, Graph, GraphArea, GraphDisplay } from '../styles'
import CurrentMonthChart from 'CRM/components/CurrentMonthChart'
import LastMonthChart from 'CRM/components/LastMonthChart'
import {useIsMobile} from "../../../components/IsMobile";

export const ToLastMonth = () => {
  const IsMobile = useIsMobile();

  return (
    <CurrentDepositWrapper IsMobile={IsMobile}>
      <DepositTitle IsMobile={IsMobile}>지난달 대비 입금 금액</DepositTitle>
      <GraphDisplay>
        <LastMonthChart />
        <CurrentMonthChart />
      </GraphDisplay>
    </CurrentDepositWrapper>
  )
}

export default React.memo(ToLastMonth)